import { TrainingProgramRecord } from '@app/models/training/training-program-record.model';
import { CheckListFilter } from '@app/modules/table/classes/column-filters/check-list/check-list-filter.class';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { AuthService } from '@app/services';
import { TrainingProgram } from '@models/training/training-program.model';

export class TrainingProgramColumn extends Column {
    title = 'training.trainingProgramName';
    property = 'trainingProgram.name';
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(trainingProgramRecord: TrainingProgramRecord) {
        if (!trainingProgramRecord.trainingProgram.isRecurring || !trainingProgramRecord.sessionNumber) {
            return trainingProgramRecord.trainingProgram.name;
        }

        return `${trainingProgramRecord.trainingProgram.name} #${trainingProgramRecord.sessionNumber} `;
    }

    constructor(protected auth: AuthService) {
        super();

        if (!this.auth.can(TrainingProgram.managePermission)) {
            return;
        }

        const options = TrainingProgram.query()
            .all()
            .then(([programs]) =>
                programs.map((program: TrainingProgram) => ({
                    label: program.name,
                    value: program.id,
                }))
            );

        this.filter = new CheckListFilter('trainingProgramId', options);
    }
}
